// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"zT","selections":"AT","facetClass":"BT","pillsDesktopSearchMenu":"CT"};